export const saturdayAbbreviatedLowercase = "Eqa";
export default {saturdayAbbreviatedLowercase};